import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useShippingMethodStyles = makeStyles({
    contentWrapper: {
        ...shorthands.padding(tokens.spacingVerticalXXL)
    },
    shippingCard: {
        backgroundColor: tokens.colorNeutralBackground4,
        ...shorthands.borderRadius('16px')
    },
    cardHeader: {
        fontSize: tokens.fontSizeHero700,
        fontWeight: tokens.fontWeightBold,
        paddingBottom: tokens.spacingVerticalXXL,
        ...shorthands.borderBottom('2px', 'solid', tokens.colorNeutralBackground5)
    },
    radioGroup: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: tokens.spacingVerticalS,
        paddingRight: tokens.spacingVerticalL
    },
    radioItem: {
        width: '100%',
        backgroundColor: tokens.colorNeutralBackground1,
        ...shorthands.borderRadius('16px')
    },
    radioText: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    methodCost: {
        alignSelf: 'center',
        ...shorthands.padding(tokens.spacingVerticalS)
    }
});

export default useShippingMethodStyles;
